import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  TeamOutlined,
  FunnelPlotOutlined,
  LineChartOutlined,
  RiseOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <TeamOutlined />,
  1: <FunnelPlotOutlined />,
  2: <LineChartOutlined />,
  3: <CustomerServiceOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("crm");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-crm-section dev-crm-benefits-section">
      <div className="dev-crm-section-inner">
        <h2 className="dev-section-h2 dev-crm-section-h2">
          <span className="dev-crm-section-h2-icon dev-crm-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-crm-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-crm-benefit-card">
              <div className="dev-crm-benefit-left">
                <span className="dev-crm-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-crm-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-crm-benefit-body">
                <div className="dev-crm-benefit-title">{item.title}</div>
                <div className="dev-crm-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
